var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88881 14.4446C5.82056 14.4446 3.33325 11.9573 3.33325 8.88905C3.33325 5.8208 5.82056 3.3335 8.88881 3.3335C11.9571 3.3335 14.4444 5.8208 14.4444 8.88905C14.4444 10.1225 14.0424 11.2621 13.3622 12.184L16.1447 14.9665C16.4702 15.2919 16.4702 15.8195 16.1447 16.145C15.8193 16.4704 15.2917 16.4704 14.9662 16.145L12.1837 13.3625C11.2619 14.0426 10.1223 14.4446 8.88881 14.4446ZM12.7777 8.88905C12.7777 11.0368 11.0366 12.7779 8.88881 12.7779C6.74103 12.7779 4.99992 11.0368 4.99992 8.88905C4.99992 6.74128 6.74103 5.00016 8.88881 5.00016C11.0366 5.00016 12.7777 6.74128 12.7777 8.88905Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.28b0d85b7de54ca30366c31f001be06a.svg";
export { ForwardRef as ReactComponent };